module.exports = __webpack_public_path__ + "static/media/3.b5ddb141.png";